module.exports = "/_next/static/images/home-caregiver-3352eca51630930ef1627df8b9063b07.png";